// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"vQ-z","inlineTitle":"wQ-z","sponsoredAdsWrapper":"xQ-z","marketplaceRecosWrapper":"yQ-z"};